/* tslint:disable */
/* eslint-disable */
/**
 * Ion.Reporting.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  MonitoredPropertiesMeterLocation,
  MonitoredPropertiesMeterLocationFromJSON,
  MonitoredPropertiesMeterLocationFromJSONTyped,
  MonitoredPropertiesMeterLocationToJSON,
  ReportsMeterDiagnostic,
  ReportsMeterDiagnosticFromJSON,
  ReportsMeterDiagnosticFromJSONTyped,
  ReportsMeterDiagnosticToJSON,
} from "./";

/**
 *
 * @export
 * @interface ReportsMeterDiagnosticEntry
 */
export interface ReportsMeterDiagnosticEntry {
  /**
   *
   * @type {MonitoredPropertiesMeterLocation}
   * @memberof ReportsMeterDiagnosticEntry
   */
  location?: MonitoredPropertiesMeterLocation;
  /**
   * Time when a reading was last successfully reported by the meter
   * @type {Date}
   * @memberof ReportsMeterDiagnosticEntry
   */
  lastReadingAt?: Date | null;
  /**
   *
   * @type {ReportsMeterDiagnostic}
   * @memberof ReportsMeterDiagnosticEntry
   */
  diagnostic?: ReportsMeterDiagnostic;
}

export function ReportsMeterDiagnosticEntryFromJSON(json: any): ReportsMeterDiagnosticEntry {
  return ReportsMeterDiagnosticEntryFromJSONTyped(json, false);
}

export function ReportsMeterDiagnosticEntryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReportsMeterDiagnosticEntry {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    location: !exists(json, "location") ? undefined : MonitoredPropertiesMeterLocationFromJSON(json["location"]),
    lastReadingAt: !exists(json, "lastReadingAt")
      ? undefined
      : json["lastReadingAt"] === null
      ? null
      : new Date(json["lastReadingAt"]),
    diagnostic: !exists(json, "diagnostic") ? undefined : ReportsMeterDiagnosticFromJSON(json["diagnostic"]),
  };
}

export function ReportsMeterDiagnosticEntryToJSON(value?: ReportsMeterDiagnosticEntry | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    location: MonitoredPropertiesMeterLocationToJSON(value.location),
    lastReadingAt:
      value.lastReadingAt === undefined
        ? undefined
        : value.lastReadingAt === null
        ? null
        : value.lastReadingAt.toISOString(),
    diagnostic: ReportsMeterDiagnosticToJSON(value.diagnostic),
  };
}
